export const decodeParam = (paramString = '') => (
  paramString
    .substring(
      paramString.indexOf('?') === -1 ? 0 : paramString.indexOf('?') + 1,
    )
    .split('&')
    .reduce((acc, item) => {
      const [param, value] = item.split('=');
      return param
        ? {
          ...acc,
          [param]: decodeURIComponent(value || ''),
        }
        : acc;
    }, {})
);

export const objectToParams = (params: any) => `?${Object.keys(params)
  .map(param => `${param}=${encodeURIComponent(params[param])}`)
  .join('&')}`;

export const slugify = (...args: (string | number)[]): string => {
  const value = args.join(' ');

  return value
    .normalize('NFD') // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, '-'); // separator
};
